import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4">
      <div className="container mx-auto flex justify-center items-center">
        <span className="text-sm">
          &copy; 2024 Marius Baldovin. All rights reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
